import { User } from 'types/types';

export enum ErulRegistrationCodes {
  ERUL_NEW = '01',
  ERUL_IN_PROGRESS = '02',
  ERUL_SUCCESS = '03',
  ERUL_ERROR = '04',
  ERUL_NOT_COMPLETED = '05',
}

export type ErulRegistrationStatus = {
  id: string;
  name: string;
  code: ErulRegistrationCodes;
  text: string | null;
};

export type ErulRegistration = {
  id?: string;
  requestId: string;
  status: ErulRegistrationStatus;
  user: User;
  requestDate: string;
  responseDate?: string;
};
